import * as React from "react";

const ConsultantIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="74"
    height="70"
    fill="none"
    viewBox="0 0 74 70"
  >
    <g filter="url(#filter0_d_2732_3384)">
      <rect
        width="64.444"
        height="60"
        x="5"
        y="4"
        fill="#E9EAEC"
        rx="27.371"
      ></rect>
    </g>
    <g stroke="#757576" clipPath="url(#clip0_2732_3384)">
      <path
        strokeLinecap="round"
        d="M48.699 41c.999 0 1.793-.629 2.507-1.508 1.46-1.8-.938-3.237-1.852-3.942-.93-.716-1.968-1.121-3.02-1.217M45 31.667A3.333 3.333 0 0 0 45 25M25.3 41c-1 0-1.794-.629-2.507-1.508-1.46-1.8.937-3.237 1.852-3.942.93-.716 1.968-1.121 3.02-1.217m.667-2.666a3.333 3.333 0 0 1 0-6.667"
      ></path>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M31.777 37.146c-1.362.842-4.934 2.562-2.759 4.715 1.063 1.051 2.247 1.803 3.735 1.803h8.492c1.488 0 2.671-.752 3.734-1.803 2.176-2.153-1.396-3.873-2.759-4.715a9.94 9.94 0 0 0-10.443 0"
      ></path>
      <path d="M41.665 27.003a4.667 4.667 0 1 1-9.333 0 4.667 4.667 0 0 1 9.333 0Z"></path>
    </g>
    <defs>
      <clipPath id="clip0_2732_3384">
        <path fill="#fff" d="M21 17h32v32H21z"></path>
      </clipPath>
      <filter
        id="filter0_d_2732_3384"
        width="73.204"
        height="68.759"
        x="0.621"
        y="0.715"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        ></feColorMatrix>
        <feOffset dy="1.095"></feOffset>
        <feGaussianBlur stdDeviation="2.19"></feGaussianBlur>
        <feComposite in2="hardAlpha" operator="out"></feComposite>
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"></feColorMatrix>
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2732_3384"
        ></feBlend>
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_2732_3384"
          result="shape"
        ></feBlend>
      </filter>
    </defs>
  </svg>
);

export default ConsultantIcon;
